//
import { mapActions, mapState } from 'vuex'
import {
    CrudDataTableDialogPicker,
    ModelForm,
} from '@/components/reusable_components/next'

//
import PurchaseInvoiceModel from '@/models/Purchase/PchPurchaseInvoice'
import PurchaseInvoiceFilters from '@/views/Purchase/PchPurchaseInvoice/list/filters'
import PurchaseInvoiceHeaders from '@/views/Purchase/PchPurchaseInvoice/list/headers'
import PurchaseOrderModel from '@/models/Purchase/PchPurchaseOrder'
import Translator from '@/services/translator'

//
import fields from './fields'

//
export default {
    name: 'purchase-order-update',
    components: {
        CrudDataTableDialogPicker,
        ModelForm,
    },
    computed: {
        //
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),

        /**
         *
         */
        dialogProps() {
            return {
                filters: PurchaseInvoiceFilters,
                headers: PurchaseInvoiceHeaders,
                service: PurchaseInvoiceModel,
            }
        },

        /**
         * 
         */
        fieldsProps() {
            return {
                is_service: this.formData.is_service
            }
        },

        /**
         *
         */
        formProps() {
            return {
                editable: false,
                fields: fields(this.fieldsProps),
                loading: this.formBusy,
                switchEdit: this.$can('EXECUTE_RECEIVE_PURCHASE_ORDER'),
            }
        },
    },
    data() {
        return {
            dialog: false,
            formBusy: false,
            formData: {},
        }
    },
    methods: {
        //
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),

        //
        ...mapActions('SnackbarModalModule', {
            setErrorSnackbar: 'setErrorSnackbar',
            setSuccessSnackbar: 'setSuccessSnackbar',
        }),

        /**
         *
         */
        close(model) {
            model
                .close()
                .then(this.successClose)
                .then(this.redirect)
                .catch(this.showError)
                .then(this.$refs.form.setWait)
        },

        /**
         *
         */
        closePartially(model) {
            model
                .closePartially()
                .then(this.successClosePartially)
                .then(this.redirect)
                .catch(this.showError)
                .then(this.$refs.form.setWait)
        },

        /**
         *
         */
        fetch() {
            PurchaseOrderModel.modeler()
                .find(this.$route.params.id)
                .finally(this.toggleFormBusy)
                .then(this.setFormData)
        },

        /**
         *
         */
        mapInvoiceNumber: ({ invoice_number }) => invoice_number,

        /**
         *
         */
        redirect() {
            this.$router.push({ name: 'purchase-order-emitted' })
        },

        /**
         *
         */
        reset() {
            this.toggleFormBusy().then(this.fetch)
        },

        /**
         *
         */
        setFormData(model) {
            this.formData = model.reset()
        },

        /**
         *
         */
        showError(error) {
            this.setErrorSnackbar(
                Translator(PurchaseOrderModel, error.response.data)
            )
        },

        /**
         *
         */
        successClose() {
            this.setSuccessSnackbar('Orden de compra recepcionada y cerrada.')
        },

        /**
         *
         */
        successClosePartially() {
            this.setSuccessSnackbar(
                'Orden de compra recepcionada parcialmente.'
            )
        },

        /**
         *
         */
        submitClose() {
            this.$refs.form.setWait(true).then(this.close)
        },

        /**
         *
         */
        submitClosePartially() {
            this.$refs.form.setWait(true).then(this.closePartially)
        },

        /**
         *
         */
        submitInvoice() {
            this.dialog = true
        },

        /**
         *
         */
        submitSelectedInvoice(event) {
            this.formData._invoice_numbers = event.selected.map(
                this.mapInvoiceNumber
            )
        },

        /**
         *
         */
        async toggleFormBusy() {
            this.formBusy = !this.formBusy
        },
    },
    beforeMount() {
        this.setTitleTopBar('Recepción de orden de compra')
    },
    mounted() {
        this.reset()
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_DETAIL_PURCHASE_ORDER')) ctx.$router.push('/')
        })
    },
}
